import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // title = 'Futsal Oz';
  headerEnable = true;

  constructor(public router: Router, public _AuthService: AuthService) {
    let s = document.createElement("script");
    s.type = "text/javascript";
    s.src = environment.SQUARE_SANDBOX.URL;
    let head: any = document.getElementsByTagName("head");
    document.head.appendChild(s);

    router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.headerEnable = (event.url === '/login' || event.url === '/signup' || event.url === '/verify-otp' || event.url === '/forgot-password') ? false : true;
      });
  }

  login() {
    this._AuthService.noLoginData(JSON.stringify(this._AuthService.oldData));
    this.router.navigate(["/login"]);
    this._AuthService.isLoginDialog = false;
  }
}
